<template>
  <el-card>
    <div slot="header" class="clearfix">
      <span>广告花费统计</span>
    </div>

    <el-form ref="queryForm" :model="queryParams" :inline="true" label-width="100px">
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          size="mini"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" :loading="loading" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button type="success" size="mini" :loading="loading" icon="el-icon-search" @click="exportData">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      border
      :data="tableData"
      :default-expand-all="false"
      row-key="date"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      style="width: 100%;margin-bottom: 20px;"
    >

      <el-table-column
        prop="date"
        label="日期"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 0">{{ scope.row.date }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="channel"
        label="渠道"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 0">{{ scope.row.channel }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="platform"
        label="平台"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 0">{{ scope.row.platform }}</span>
          <span v-else>全部</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="cost"
        label="花费"
        align="center"
      >
        <template scope="scope">${{ scope.row.cost }}</template>
      </el-table-column>
      <el-table-column
        prop="country"
        label="国家"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.type === 0">{{ scope.row.country }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="impressions"
        label="曝光数"
        align="center"
      >
        <template scope="scope">
          <span>{{ scope.row.impressions }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="clicks"
        label="点击数量"
        align="center"
      >
        <template scope="scope">
          <span>{{ scope.row.clicks }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="conversions"
        label="安装数量"
        align="center"
      />
      <el-table-column
        prop="click_rate"
        label="点击率"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="260"
            trigger="hover"
            content="点击率=点击数量/曝光数 "
          >
            <span slot="reference">点击率 <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template scope="scope">
          <span>{{ scope.row.click_rate }}%</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="click_rate"
        label="转换率"
        align="center"
      >
        <template slot="header">
          <el-popover
            placement="top-start"
            width="260"
            trigger="hover"
            content="转换率=安装数量/点击数 "
          >
            <span slot="reference">转换率 <i class="el-icon-warning-outline" /></span>
          </el-popover>
        </template>
        <template scope="scope">
          <span>{{ scope.row.conversion_rate }}%</span>
        </template>
      </el-table-column>

    </el-table>

    <totalStat ref="ad" />
  </el-card>
</template>

<script>
import { getAdReportStat } from '@/api/statistics/user_remain'
import { getCacheQuery, getLastDates, setCacheQuery } from '@/utils'
import totalStat from '@/views/config/ad-report-stat/components/echart.vue'

export default {
  name: 'AdViewStat',
  components: {
    totalStat
  },
  data() {
    return {
      loading: false,
      queryParams: {
        startDate: '',
        endDate: '',
        level: 1
      },
      tableData: []
    }
  },
  created() {
    this.queryParams.startDate = getLastDates(7)
    this.queryParams.endDate = getLastDates(1)
    this.getTables(undefined)
  },
  methods: {
    handleQuery() {
      if (!this.queryParams.startDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (!this.queryParams.endDate) {
        this.msgError('请选择开始日期')
        return
      }
      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }
      this.getTables({})
    },
    getTables(event) {
      this.loading = true
      this.queryParams.level = 0
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getAdReportStat(this.queryParams).then(res => {
        this.loading = false
        setCacheQuery(this.$options.name, this.queryParams)
        this.tableData = res.data.data
        this.$refs.ad.refresh(this.tableData)
      })
    },
    exportData() {
      this.loading = true
      this.queryParams.level = 1
      getAdReportStat(this.queryParams).then(res => {
        this.loading = false
        window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
      })
    }
  }

}
</script>

<style scoped>
.mtop{
  margin-top: 20px;
}
</style>
